import { authGet } from "@api";
import { DEPLOYMENT_URL } from "@constants";
import { Permission } from "@types";

import { Integration } from "@pages/settings/types";

export const fetchIntegrationsIfPermitted = (
  deploymentId: string,
  permissions: Permission[]
) => {
  if (!permissions.includes(Permission.panel_policy)) {
    return Promise.resolve({ integrations: [] });
  }

  return authGet<{ integrations: Integration[] }>(
    `${DEPLOYMENT_URL}/${deploymentId}/integrations`
  );
};
